module.exports = __webpack_public_path__ + "static/media/arrow-right-solid.d3cb98eb.png";